<template>
  <div>
    <a
      v-show="false"
      href="#"
      id="btnIntroduction"
      class="btn add-btn"
      data-toggle="modal"
      data-target="#infoIntroduction"
    >
      <i class="fa fa-plus"></i> Introduction Btn
    </a>
    <!-- Add Client Modal -->
    <div id="infoIntroduction" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">2 Langkah Mudah Memulai Waajo</h5>
            <button
              id="btnClose"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form-wizard
              :title="''"
              :subtitle="''"
              :finishButtonText="'Mulai'"
              :start-index.sync="activeIndex"
              color="#70C95A"
            >
              <Skeleton v-if="isLoading" :count="1" />
              <wizard-step
                slot-scope="props"
                slot="step"
                :tab="props.tab"
                :transition="props.transition"
                :index="props.index"
              >
                <div
                  slot="active-step"
                  style="display: flex; justify-content: center; align-items: center"
                >
                  <lottie
                    v-if="props.index == 0"
                    :options="animationsForm1"
                    :height="65"
                    :width="65"
                  />
                  <lottie
                    v-else-if="props.index == 1"
                    :options="animationsForm2"
                    :height="65"
                    :width="65"
                  />
                  <lottie
                    v-else-if="props.index == 2"
                    :options="animationsForm3"
                    :height="65"
                    :width="65"
                  />
                </div>
              </wizard-step>
              <tab-content title="Welcome" icon="fa fa-list-alt">
                <div class="text-center">
                  <lottie :options="animationsForm1" :height="200" :width="200" />
                </div>
                <div class="text-left">
                  <!-- {{memberSessionArr}} -->
                  Hai kak
                  <b>{{memberSessionArr.name}}</b>, selamat karena telah terdaftar di Waajo.
                  <div
                    class="badge badge-warning text-center"
                  >Tingkatkan omset berkali-kali lipat dengan whatsapp marketing by Waajo.</div>
                  <!-- <br />Berikut ini adalah 2 langkah mudah untuk memulai: -->
                </div>
              </tab-content>

              <tab-content title="Redeem  Voucher" icon="fa fa-list-alt">
                <div class="text-left">
                  Redeem atau gunakan active voucher.
                  <ul>
                    <li>
                      Masuk ke menu Order -->
                      <a
                        target="_blank"
                        href="https://apps.waajo.id/order/active_voucher"
                      >Active Voucher</a>
                    </li>
                    <li>Pada tombol option pilih Create a new License.</li>
                    <li>Setelahnya kamu isikan data-data termasuk no telp Whatsapp yang akan kamu gunakan.</li>
                  </ul>

                  <br />Cek video tutorial berikut :
                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=l4Xqg2xQBgw&t=2s"
                  >https://www.youtube.com/watch?v=l4Xqg2xQBgw&t=2s</a>
                  <br />
                  <br />
                  <span class="text-muted">
                    Note:
                    <br />Pastikan kamu sudah melakukan pembelian untuk mendapatkan Active Voucher.
                    <br />
                    <center>
                      <a
                        class="btn btn-primary btn-sm"
                        target="_blank"
                        href="https://apps.waajo.id/subscriptions"
                      >
                        <i class="fa fa-shopping-cart"></i> Buy Voucher
                      </a>
                    </center>
                  </span>
                </div>
              </tab-content>
              <tab-content title="Scan QRCode" icon="fa fa-list-alt">
                <div class="text-left">
                  Setelah Redeem Voucher, Kita akan ke step scanning no Whatsapp kamu ke Waajo.
                  <br />
                  <ul>
                    <li>
                      Masuk ke menu Licenses -->
                      <a
                        href="https://apps.waajo.id/license/list?license_status="
                        target="_blank"
                      >All Licenses</a> --> Klik tombol Profile &amp; Scan QRCode
                    </li>
                    <li>
                      Lalu akan diarahkan ke menu Profile, klik icon
                      <i class="fa fa-qrcode"></i> dan tunggu beberapa saat hingga Popup QRCode tampil.
                    </li>
                    <li>Setelahnya Waajo kakak akan aktif. Pastikan mendapat pesan Whatsapp dari Waajo terkait status telah terhubung</li>
                  </ul>
                  <br />Cek video tutorial berikut :
                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=7cAwq3_X46k&ab_channel=waajoindonesia"
                  >https://www.youtube.com/watch?v=7cAwq3_X46k&ab_channel=waajoindonesia</a>
                  <br />
                  <br />
                  <span class="text-muted">
                    Untuk panduan lainnya bisa kunjungi halaman
                    <a
                      target="_blank"
                      href="https://help.waajo.id/"
                    >Help Desk</a> atau
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UCvW5ivbvIoBCyC4tXhHbh5A"
                    >Youtube</a> kami.
                  </span>
                </div>
              </tab-content>

              <template slot="footer" slot-scope="props">
                <table class="table table-borderless">
                  <tr>
                    <td class="text-left">
                      <wizard-button
                       class="btn btn-outline-light"
                        v-if="props.activeTabIndex == 0"
                        @click.native="onComplete"
                        :style="props.fillButtonStyle"
                      >Lewati</wizard-button>
                      <wizard-button
                        v-else-if="props.activeTabIndex > 0"
                        @click.native="props.prevTab()"
                        :style="props.fillButtonStyle"
                      >Sebelumnya</wizard-button>
                    </td>
                    <td class="text-right">
                      <wizard-button
                        v-if="!props.isLastStep"
                        @click.native="props.nextTab()"
                        class="wizard-footer-right"
                        :style="props.fillButtonStyle"
                      >Lanjut</wizard-button>
                      <wizard-button
                        v-else
                        @click.native="onComplete()"
                        class="wizard-footer-right finish-button"
                        :style="props.fillButtonStyle"
                      >{{props.isLastStep ? 'Selesai' : 'Lanjut'}}</wizard-button>
                    </td>
                  </tr>
                </table>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Lottie from "vue-lottie";
import animationStore from "@/assets/lottie/viralPost.json";
import fileAnimationsForm1 from "@/assets/lottie/jumping-happy.json";
import fileAnimationsForm3 from "@/assets/lottie/scan-qrcode-success.json";

import {
  FormWizard,
  TabContent,
  WizardStep,
  WizardButton
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  components: {
    Lottie,
    FormWizard,
    TabContent,
    WizardStep,
    WizardButton
  },
  data() {
    return {
      activeIndex: 0,
      animationsForm1: { animationData: fileAnimationsForm1, loop: true },
      animationsForm2: { animationData: animationStore, loop: true },
      animationsForm3: { animationData: fileAnimationsForm3, loop: true },
      isLoading: false,
      totalRecords: 0,
      totalTagihan: 0
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    }
  },
  async created() {
    if (
      typeof this.memberSessionArr.roles != "undefined" &&
      this.memberSessionArr.roles.length
    ) {
      this.memberSessionArr.roles.forEach((role, idx) => {
        if (role == "member") {
          this.showData();
        }
      });
    }
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async onComplete() {
      console.log("complete step");
      this.$store.dispatch("tour/updateHasTourIntroduction").then(() => {
        document.getElementById("btnClose").click(); // Click on the checkbox
        this.$store.dispatch("login/getProfile");
      });
    },
    async showData() {
      this.loading = await true;
      if (this.memberSessionArr.has_tour_introduction == 0) {
        document.getElementById("btnIntroduction").click(); // Click on the checkbox
      }
      this.loading = await false;
    }
  },

  mounted() {},
  name: "introduction"
};
</script>
<style scoped>
.wizard-progress-with-circle {
  display: none;
}
.wizard-nav.wizard-nav-pills {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/components/Introduction.vue